import { gql } from "@apollo/client";

export const PROCESS_STATUSES = gql`
  query ProcessStatuses($where: ProcessStatusWhereInput, $isIn: JSONObject) {
    processStatuses(where: $where, isIn: $isIn) {
      data {
        id
        name
        tag
        process {
          id
        }
        actions {
          id
          type
          args
          conditions {
            id
            operation
            rightOperand
            leftOperand
          }
        }
      }
      count
    }
  }
`;

export const PROCESS_STATUS = gql`
  query ProcessStatus($where: ProcessStatusWhereInput) {
    processStatus(where: $where) {
      id
      name
      tag
      config
    }
  }
`;

export const PROCESS_STATUS_OWNERS = gql`
  query ProcessStatusOwners($isIn: JSONObject) {
    processStatuses(isIn: $isIn) {
      data {
        id
        process {
          id
        }
      }
    }
  }
`;

const processStatuses = {
  PROCESS_STATUSES,
  PROCESS_STATUS,
  PROCESS_STATUS_OWNERS,
};

export default processStatuses;
